import React from "react";

export function Footer() {
  return (
    <footer className="mt-8 pt-6 pb-6 border-t border-slate-200 dark:border-slate-800 flex items-center justify-center">
      <p className="text-sm text-muted-foreground font-medium text-center">
        &copy; 2026 XeroAlpha. All rights reserved.
      </p>
    </footer>
  );
}
